import { ExtractRuntimeControlConfigsProps } from './runtime-control.types';

/**
 * Resolves runtime configs for a given environment and optional app.
 *
 * Resolution order:
 * 1. Environment + app-specific override (when available)
 * 2. Environment `default` config
 * 3. `undefined` when the environment block does not exist
 *
 * @template TConfig Config object shape stored in each environment bucket.
 * @param params Resolver input including instance, optional app, and configs map.
 * @returns The resolved runtime config for the target instance/app.
 */
export function extractRuntimeControlConfigs<TConfig>({
  instanceName,
  appName,
  configs,
}: ExtractRuntimeControlConfigsProps<TConfig>): TConfig | undefined {
  const instanceConfigs = configs?.[instanceName];
  if (!instanceConfigs) return undefined;
  if (!appName || !instanceConfigs[appName]) return instanceConfigs.default;
  return instanceConfigs[appName];
}
